<template>
  <van-popup :value="value" @input="input" position="center" round style="width:90vw">
    <div class="flex flex-col items-center p-4">
      <DeviceName :legal="legalDevice" :device-id="tagId" :device-name="deviceName"/>

      <div style="width: 80%" class="mt-4" v-if="legalDevice">
        <HistoryCurve :max-power="10" :resistance="1.2" :power="power" :device-level="level"
            curve-color="#679AFF"
            :curve-line-color="[
             {offset:1,color:'rgba(0, 60, 255, 1)'},
             {offset:0.75,color:'rgba(108, 158, 255, 0.75)'},
             {offset:0,color:'rgba(255, 255, 255, 0)'}
          ]"/>
      </div>

      <div  class="mt-1 main-color" >
        <van-loading v-if="loading" size="24px">Loading ingredient...</van-loading>
        <div v-else class="text-12px  text-center"><span v-if="legalDevice">{{ingredientText}}</span></div>
      </div>

      <div v-if="showButton" class="flex flex-row items-center text-center gap-3 mt-10 w-full">
        <div @click="onWriteClick" class="flex-1 text-white write-btn"
            style="background: #121212">Complete
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import DeviceName from "@/components/home/DeviceName.vue";
import HistoryCurve from "@/views/HistoryCurve.vue";
import { mapState } from "vuex";

export default {
  name: "PopupDeviceCurve",
  components: { HistoryCurve, DeviceName },
  props: {
    showButton: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: true
    },
    level: {
      type: Number,
      default: 1
    },
    ingredientText: {
      type: String,
      default: ""
    },
    deviceName: {
      type: String,
      default: ""
    },
    power: {
      type: Array,
      default: () => []
    },
    tagId: {
      type: String,
      default: ""
    },
    legalDevice: {
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
    };
  },
  methods: {
    input(e) {
      this.$emit("input", e);
    },
    onWriteClick() {
      this.$emit("input", false);
      this.$emit('close')
    }
  },
  computed: {
    ...mapState("nfc", ["writerSetting"])
  },
  mounted() {

  }
};
</script>

<style scoped lang="less">

.flavor-name-tags {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-x: scroll;

  .flavor-name {
    font-size: 15px;
  }

  .flavor-tag-content {
    margin-top: 10px;
    display: flex;
    flex: 1;
    font-size: 10px;
    flex-direction: row;
    align-items: center;
    overflow-x: scroll;

    .flavor-tag {
      border-radius: 8px;
      background: var(--modeActiveBackground) !important;
      color: var(--modeActiveTextColor) !important;
      padding: 4px 8px;
      margin-right: 4px;
    }
  }
}

.write-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>